export default __webpack_public_path__ + "static/castright-5a267e1508b33567c61d066525fa2cce.svg";